import { render, staticRenderFns } from "./SignOutMessage.component.vue?vue&type=template&id=13a83bec&"
import script from "./SignOutMessage.component.vue?vue&type=script&lang=ts&"
export * from "./SignOutMessage.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports